import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { fetchEventsList } from 'gqlQueries/promoRecommendation';
import {
    eventsListDataParser,
    recommendationCalenderTableParser,
    recommendationExportParser,
    recommendationKpiTableDataParser,
} from 'parser/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';
import { FilterContextData } from 'contexts/FilterContext';

const errorMessage: string = 'Something went wrong!';

function useFetchEventsList() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);
    const { currentFrequency } = useContext(FilterContextData);

    const [getEventsList, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useLazyQuery(fetchEventsList, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
            fetchPolicy: 'cache-and-network',
        });

    const deleteEvent = useCallback(
        (index: number) => {
            const eventsListData = [...data?.eventsData] || [];
            const calenderTableData = [...data?.calenderData] || [];
            const kpiTableData = [...data?.kpiData] || [];

            //removing event at index
            eventsListData.splice(index, 1);
            calenderTableData.splice(index, 1);
            kpiTableData.splice(index, 1);

            //if length ===1 then it means only tooltip object is present, then remove it
            if (calenderTableData.length === 1) calenderTableData.splice(0, 1);
            setData({ eventsData: eventsListData, calenderData: calenderTableData, kpiData: kpiTableData });
        },
        [data],
    );

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPlanEventsData } = payload;
            if ('eventsData' in getPlanEventsData) {
                const eventsListData = eventsListDataParser(getPlanEventsData.eventsData);
                const calenderTableData = recommendationCalenderTableParser(
                    {
                        data: getPlanEventsData.eventsData,
                        startWeek: getPlanEventsData?.calendarDetailsData?.startDates,
                        endWeek: getPlanEventsData?.calendarDetailsData?.endDates,
                    },
                    appConfig,
                    currentFrequency,
                );
                //if length ===1 then it means only tooltip object is present, then remove it
                if (calenderTableData.length === 1) calenderTableData.splice(0, 1);
                const kpiTableData = recommendationKpiTableDataParser(getPlanEventsData.eventsData, appConfig);
                const exportData = recommendationExportParser(kpiTableData, eventsListData);
                setData({
                    exportData: exportData,
                    eventsData: eventsListData,
                    calenderData: calenderTableData,
                    kpiData: kpiTableData,
                });
                return;
            }
            //const featureGroup = payload;
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //function to clear the events list to default
    const clearEventsList = useCallback(() => {
        setData(null);
        setError(null);
    }, []);
    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        deleteEvent,
        clearEventsList,
        fetchEventsList: (variables: any) => {
            setData(null);
            setError(null);
            setLoading(true);
            getEventsList(variables);
        },
    };
}

export { useFetchEventsList };
